"use client";

import { useEffect, useState } from "react";

const benefits = [
    "No auction cars.",
    "No haggling.",
    "No dealer fees.",
    "Money-back guarantee."
];

export default function SRPBenefitsBar() {
    // Keep server and initial client markup identical. Choose once after mount,
    // so filtering, resizing, and reduced-motion preferences never start rotation.
    const [mobileIndices, setMobileIndices] = useState([0, 2]);

    useEffect(() => {
        const firstIndex = Math.floor(Math.random() * benefits.length);
        // Pick from the remaining positions, skipping the first selection.
        const remainingIndex = Math.floor(Math.random() * (benefits.length - 1));
        const secondIndex = remainingIndex >= firstIndex ? remainingIndex + 1 : remainingIndex;
        setMobileIndices([firstIndex, secondIndex].sort((a, b) => a - b));
    }, []);

    return (
        <aside aria-label="The THIScar difference" className="t-bg-brand-yellow t-text-brand-ink">
            <ul role="list" className="t-m-0 t-flex t-list-none t-items-stretch t-justify-center t-px-4 t-py-3 sm:t-px-6">
                {benefits.map((benefit, index) => {
                    const mobilePosition = mobileIndices.indexOf(index);
                    return (
                        <li
                            key={benefit}
                            className={`${mobilePosition < 0 ? "t-hidden md:t-flex" : "t-flex"} ${mobilePosition === 1 ? "t-border-l" : "t-border-l-0"} t-min-w-0 t-w-1/2 t-items-center t-justify-center t-border-solid t-border-brand-ink/20 t-px-3 t-text-center t-text-xs t-font-bold t-leading-5 md:t-w-auto md:t-px-6 md:t-text-sm ${index > 0 ? "md:t-border-l" : "md:t-border-l-0"}`}>
                            {benefit}
                        </li>
                    );
                })}
            </ul>
        </aside>
    );
}
